import { render, staticRenderFns } from "./red_dot_channel.vue?vue&type=template&id=3ba64336&scoped=true"
import script from "./red_dot_channel.vue?vue&type=script&lang=js"
export * from "./red_dot_channel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba64336",
  null
  
)

export default component.exports